export const CLASS_NAMES = {
  container: 'flex flex-1 flex-col',
  title: 'text-style-g text-neutral-600 mb-4',
};

export const TITLE = 'Results';
